import { create } from 'zustand';
import { Message } from '../lib/types';
import { persist } from 'zustand/middleware';

interface SimulationState {
  isSimulating: boolean;
  simulationProgress: {
    persona: string;
    current: number;
    total: number;
    turn: number;
    totalTurns: number;
  } | null;
  selectedSimulation: string | null;
  selectedSimulations: string[];
  personaSimulations: Record<string, string | null>;
  personaMessages: Record<string, Message[]>;
  selectedPersonas: string[];
  selectedPersonaTab: string | null;
  setSimulationState: (state: Partial<SimulationState>) => void;
  resetSimulation: () => void;
}

export const useSimulationStore = create<SimulationState>()(
  persist(
    (set) => ({
      isSimulating: false,
      simulationProgress: null,
      personaMessages: {},
      personaSimulations: {},
      selectedPersonas: [],
      selectedPersonaTab: null,
      selectedSimulation: null,
      selectedSimulations: [],
      setSimulationState: (state) => set(state),
      resetSimulation: () =>
        set({
          isSimulating: false,
          simulationProgress: null,
          personaMessages: {},
          personaSimulations: {},
          selectedPersonas: [],
          selectedPersonaTab: null,
          selectedSimulation: null,
          selectedSimulations: [],
        }),
    }),
    {
      name: 'simulation-storage',
    },
  ),
);
